import { useConfigContext } from "@/state/configContext";
import { useAdminContext } from "@/state/adminContext";
import type { RefObject } from "react";

export type CuentasProp = {
  cuentas: {
    id: number;
    nombre: string;
  }[];
};

export function SelectCuenta({
  ref,
  cuentas,
  value,
  onChange,
}: {
  ref?: RefObject<HTMLSelectElement | null>;
  value?: number;
  onChange?: (v: number) => unknown;
} & CuentasProp) {
  return (
    <select
      ref={ref}
      {...(value ? { value } : { defaultValue: cuentas[0].id || 0 })}
      onChange={(e) => onChange?.(Number(e.target.value))}
    >
      {cuentas.map((cuenta) => (
        <option key={cuenta.id} value={cuenta.id}>
          {cuenta.nombre}
        </option>
      ))}
    </select>
  );
}

export function SelectMoneda({
  ref,
  value,
  onChange,
}: {
  ref?: RefObject<HTMLSelectElement | null>;
  value?: string;
  onChange?: (moneda: string) => unknown;
}) {
  const { moneda } = useConfigContext();
  const { monedas } = useAdminContext();

  return (
    <select
      ref={ref}
      {...(value ? { value } : { defaultValue: moneda })}
      onChange={(e) => onChange?.(e.target.value)}
    >
      {Object.keys(monedas).map((m) => (
        <option key={m} value={m}>
          {m}
        </option>
      ))}
    </select>
  );
}
